var HumanNameTypeMixins = {
    methods: {
        humanNameType(type) {
            switch (type) {
                case 'third':
                    return this.$l10n.__('Société');
                case 'client':
                    return this.$l10n.__('Client');
                case 'prospect':
                    return this.$l10n.__('Prospect');
                case 'supplier':
                    return this.$l10n.__('Fournisseur');
                case 'people':
                    return this.$l10n.__('Contact');
                case 'opportunity':
                    return this.$l10n.__('Opportunité');
                case 'estimate':
                    return this.$l10n.__('Devis');
                case 'invoice':
                    return this.$l10n.__('Facture');
                case 'delivery':
                    return this.$l10n.__('Bon de livraison');
                case 'order':
                    return this.$l10n.__('Bon de commande');
                case 'creditnote':
                    return this.$l10n.__('Avoir');
                case 'proforma':
                    return this.$l10n.__('Proforma');
                case 'purOrder':
                    return this.$l10n.__('Bon de commande fournisseur');
                case 'purDelivery':
                    return this.$l10n.__('Bon de livraison fournisseur');
                case 'purInvoice':
                    return this.$l10n.__('Facture fournisseur');
                case 'purCreditNote':
                    return this.$l10n.__('Avoir fournisseur');
                case 'project':
                    return this.$l10n.__('Projet');
                case 'model':
                    return this.$l10n.__('Modèle');
                case 'doc':
                    return this.$l10n.__('Document de vente');
                case 'docpurchase':
                    return this.$l10n.__('Document d’achat');
                case 'item':
                    return this.$l10n.__('Produit');
                case 'service':
                    return this.$l10n.__('Service');
                case 'declination':
                    return this.$l10n.__('Déclinaison');

                default:
                    return type;
            }
        },
    },
};

export default HumanNameTypeMixins;
